import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useShareMedia } from '@euler/functions/useShareMedia';
import { AVPlaybackStatus, ResizeMode as AVResizeMode, Video } from 'expo-av';

import { memo, useCallback, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import FastImage, { ResizeMode } from 'react-native-fast-image';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

// see https://github.com/ihmpavel/expo-video-player for more video controls customization
export const MediaPreview = memo(
  (
    props:
      | {
          type: 'photo';
          url: string;
          resizeMode?: ResizeMode;
          shareable?: boolean;
          onClose?: () => void;
        }
      | {
          type: 'video';
          url: string;
          loop?: boolean;
          resizeMode?: AVResizeMode;
          shareable?: boolean;
          controls?: boolean;
          onPlaybackStatusUpdate?: (status: AVPlaybackStatus) => void;
          onClose?: () => void;
        },
  ) => {
    const { rpx } = useResponsiveContext();
    const { top } = useSafeAreaInsets();
    const [play, setPlay] = useState(true);

    const onClose = useCallback(() => {
      if (props.type === 'video') {
        setPlay(false);
      }
      props.onClose?.();
    }, [props]);

    const { canShare, onShare } = useShareMedia({
      url: props.url,
      type: props.type,
    });

    return (
      <View
        css={`
          flex: 1;
        `}
      >
        {props.type === 'photo' && (
          <FastImage
            resizeMode={props.resizeMode ?? 'contain'}
            css={`
              flex: 1;
            `}
            source={{ uri: props.url }}
          />
        )}
        {props.type === 'video' && (
          <>
            <Video
              css={`
                flex: 1;
              `}
              source={{ uri: props.url }}
              resizeMode={props.resizeMode ?? AVResizeMode.CONTAIN}
              isLooping={props.loop}
              shouldPlay={play}
              useNativeControls={props.controls}
              onPlaybackStatusUpdate={props.onPlaybackStatusUpdate}
              videoStyle={{
                width: '100%',
                height: '100%',
              }}
            />
          </>
        )}

        <TouchableOpacity
          onPress={onClose}
          css={`
            position: absolute;
            top: ${top}px;
            right: ${rpx(15)}px;
          `}
        >
          <Icon name="close" size={rpx(44)} color="white" />
        </TouchableOpacity>

        {canShare && props.shareable && (
          <TouchableOpacity
            onPress={onShare}
            css={`
              position: absolute;
              top: ${top + rpx(60)}px;
              right: ${rpx(15)}px;
            `}
          >
            <Icon name="share-alternitive" size={44} color="white" />
          </TouchableOpacity>
        )}
      </View>
    );
  },
);
